// extracted by mini-css-extract-plugin
module.exports = {"button":"AddDashedButton_button__1F-S5","button__icon":"AddDashedButton_button__icon__1_Ly7","button__text":"AddDashedButton_button__text__2UbnS"};